import { render, staticRenderFns } from "./WaitingForTvPage.vue?vue&type=template&id=44e0f6b4&scoped=true"
import script from "./WaitingForTvPage.vue?vue&type=script&lang=js"
export * from "./WaitingForTvPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e0f6b4",
  null
  
)

export default component.exports